// @core/api/endpoints/project/list_milestones.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMilestonesResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List milestones
 * Returns all project milestones with their status and progress toward completion based on linked items.
 */
export async function ListMilestones(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMilestonesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/milestones`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListMilestonesResponse>(requestPath, { ...requestOptions, params });
}
